var staticHGKeyRE = /(.+)?\[(\d+)\]$/

module.exports = staticHGKeyRE
